import React, { useState, useEffect } from "react";
import axios from "axios";
import CardProduct from "./CardProducto.jsx";
import { useParams } from "react-router-dom";

const RecomendedProductList = () => {
    const [recomendedProducts, setRecomendedProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    // 1. Obtén el 'id' de la URL con useParams
    const { id } = useParams();

    const fetchRecomendedProducts = async () => {
        try {
            const response = await axios.get(`/products/recomended/`);
            setRecomendedProducts(response.data);
            console.log("Recomended Products:", response.data);
        } catch (error) {
            console.error("Error fetching recomended products:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRecomendedProducts();
    }, []);

    return (
        <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bebas font-bold mb-4 w-full">
                Productos recomendados
            </h2>

            {loading ? (
                <p>Cargando productos recomendados...</p>
            ) : recomendedProducts?.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {recomendedProducts.map((product) => {
                        // 2. Compara el id de la URL con el id del producto
                        const isActive = parseInt(id, 10) === product.id;

                        return (
                            <div key={product.id} className="relative">
                                {/* 3. Renderiza tu tarjeta del producto */}
                                <CardProduct product={product} />

                                {/* Si coincide, aplicamos un velo translúcido */}
                                {isActive && (
                                    <div className="rounded-xl absolute inset-0 bg-black bg-opacity-60 pointer-events-none flex text-center items-center justify-center">
                                        {/* Puedes personalizar la opacidad, color, etc. */}
                                        Actualmente te encuentras en este producto
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p className="text-gray-500">
                    No recommended products available at the moment.
                </p>
            )}
        </div>
    );
};

export default RecomendedProductList;
